import styled from 'styled-components';
import { CodeAuthIframe } from '@shared/components/CodeAuthIframe';

export const Container = styled(CodeAuthIframe).attrs(({ queryParams }) => ({
  url: 'recover-password',
  queryParams: queryParams || ['theme=dark'],
}))`
  height: 15.8em;
`;
